export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "greenlotto-themeWrapLive" */'./LiveThemeImporter'),
    ThemeImporter: () => import(/* webpackChunkName: "greenlotto-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "greenlotto-themeWrapLive" */'./LiveThemeImporter'),
    ThemeImporter: () => import(/* webpackChunkName: "greenlotto-themeWrap" */'./ThemeImporter'),
  },
};
